import { render } from "./ProfileEditedOverlay.vue?vue&type=template&id=1e6847c2"
import script from "./ProfileEditedOverlay.vue?vue&type=script&lang=js"
export * from "./ProfileEditedOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__